/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

import type React from 'react';

type ModalDispatchContextParams = {
  close: (targetModal: Omit<ModalStateParams, 'props'>) => void;
  closeAll: () => void;
  exited: (targetModal: Omit<ModalStateParams, 'props'>) => void;
  open: (targetModal: ModalStateParams) => void;
};

export type OnCloseModalParams = {
  beforeClose?: () => void;
  preventDirectClose?: boolean;
};

type ModalContainerProps<TModal = object> = TModal & {
  onClose: (params?: OnCloseModalParams) => void;
  onExited: () => void;
  autoClose?: boolean;
  modalClosingConfirmProps?: {
    description: React.ReactNode;
    title: string;
  };
  onSubmit?: () => void;
  open?: boolean;
  TransitionProps?: { onExited: () => void };
};

export type UseModalParams<TModal = object> = Omit<
  ModalContainerProps<TModal>,
  'onClose' | 'onExited' | 'TransitionProps'
>;

export type ModalComponentProps<TModal = object> = Omit<ModalContainerProps<TModal>, 'autoClose'>;

export type ModalStateParams<TModal = object> = {
  Component: any;
  props?: UseModalParams<TModal>;
  uniqueId?: string;
};

export type ModalStateContextParams<TModal = object> = ModalStateParams<TModal>[];

export const ModalDispatchContext = createContext<ModalDispatchContextParams>({
  open: () => {},
  close: () => {},
  closeAll: () => {},
  exited: () => {},
});

export const ModalStateContext = createContext<ModalStateContextParams>([]);
